var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml-2 inline-flex px-3 py-0.5 rounded-full text-xs leading-5 font-semibold tracking-wide uppercase",class:_vm.bgClass},[_vm._v("\n  "+_vm._s(_vm.tier)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }